import { BreakpointObserver } from '@angular/cdk/layout'
import { Injectable, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { map } from 'rxjs/operators'

@Injectable({
	providedIn: 'root',
})
export class CdkLayoutState {
	readonly #breakpointObserver = inject(BreakpointObserver)
	readonly #breakpoints = ['(max-width: 550px)', '(max-width: 1030px)']

	readonly #maxWidth$ = this.#breakpointObserver.observe(this.#breakpoints).pipe(
		map(({ breakpoints }) => {
			if (breakpoints[this.#breakpoints.at(0)]) {
				return 'calc(100svw - 2rem)'
			}

			if (breakpoints[this.#breakpoints.at(1)]) {
				return '50svw'
			}

			return '25vw'
		})
	)
	readonly #isSmall$ = this.#breakpointObserver
		.observe('(max-width: 550px)')
		.pipe(map(({ matches }) => matches))
	readonly isBrowser$ = this.#breakpointObserver
		.observe('(min-width: 1030px)')
		.pipe(map(({ matches }) => matches))
	readonly isBrowser = toSignal(this.isBrowser$)
	readonly maxWidth = toSignal(this.#maxWidth$)
	readonly isSmall = toSignal(this.#isSmall$)
}
